import { PeoStaffBlacklistedEmployeeInput, PeoStaffBlacklistedEmployeeKindEnum } from 'src/api';

import { EmployeeBlacklistItem } from '../types';

/** Strip the display-only fields down to the mutation input shape (id vs token). */
export const convertEmployeeBlacklist = (
  items: EmployeeBlacklistItem[],
): PeoStaffBlacklistedEmployeeInput[] =>
  items.map(item =>
    item.kind === PeoStaffBlacklistedEmployeeKindEnum.Existing
      ? { kind: item.kind, id: item.id }
      : { kind: item.kind, token: item.token },
  );
